import { render, staticRenderFns } from "./ContactAddressForm.vue?vue&type=template&id=74f6c029"
import script from "./ContactAddressForm.vue?vue&type=script&lang=js"
export * from "./ContactAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports